// --------------------------------------- Project List
export const ProjectList = [
  {
    img: '/images/myntra.jpg',
    title: 'Myntra',
    description: 'An end to end clone of Myntra.com where you can buy various e-commerce products with many features such as filter, sort to search and buy products easily.',
    tech_stack: 'React, Css, Javascript, Node.js, MongoDB, Express, EJS',
    github_url: 'https://github.com/nkil123/MyntraFullStack',
    demo_url: 'https://mysterious-depths-64439.herokuapp.com/',
  },
  {
    img: '/images/lakme.png',
    title: 'Lakme',
    description: 'An front-end clone of Lakme.com where you can buy various beauty products, sort and buy products.',
    tech_stack: 'React, Css, Javascript',
    github_url: 'https://github.com/nkil123/lakme_clone',
    demo_url: 'https://lakme-clone.vercel.app/',
  },

  // {
  //   img: '/images/oyo.png',
  //   title: 'OyoRooms',
  //   description: 'An end to end clone of oyorooms.com wich can book hotel rooms across India',
  //   tech_stack: 'React, Css, Javascript, figma',
  //   github_url: 'https://albartjose.hashnode.dev/',
  //   demo_url: 'https://albartjose.hashnode.dev/',
  // },
  // {
  //   img: "/images/oyo.png",
  //   title: "OyoRooms",
  //   description: "An end to end clone of oyorooms.com wich can book hotel rooms across India",
  //   tech_stack: "React",
  //   github_url: "https://albartjose.hashnode.dev/",
  //   demo_url: "https://albartjose.hashnode.dev/",
  // },
];

// --------------------------------------- Skills

export const stackList = [
  {
    img: 'https://img.icons8.com/color/240/000000/html-5--v1.png',
    name: 'HTML',
  },
  {
    img: 'https://img.icons8.com/color/144/000000/css3.png',
    name: 'CSS',
  },
  {
    img: 'https://img.icons8.com/color/240/000000/javascript--v1.png',
    name: 'JavaScript',
  },
  {
    img: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original.svg',
    name: 'NodeJs',
  },
  {
    img: 'https://img.icons8.com/color/48/000000/react-native.png',
    name: 'React',
  },
  {
    img: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/redux/redux-original.svg',
    name: 'Redux',
  },

  {
    img: 'https://img.icons8.com/color/144/000000/git.png',
    name: 'Git',
  },
  {
    img: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original.svg',
    name: 'mongoDB',
  },
  {
    img: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/express/express-original-wordmark.svg',
    name: 'Express',
  },
  {
    img: 'https://img.icons8.com/color/48/000000/material-ui.png',
    name: 'Material-UI',
  },
  {
    img: 'https://camo.githubusercontent.com/300c2986a53648631c34798554da7cde3779de253b02a15da6bccc59ea9f0317/68747470733a2f2f63646e2e776f726c64766563746f726c6f676f2e636f6d2f6c6f676f732f6e6578746a732d332e737667',
    name: 'NextJs',
  },
  {
    img: 'https://camo.githubusercontent.com/93b32389bf746009ca2370de7fe06c3b5146f4c99d99df65994f9ced0ba41685/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f676574706f73746d616e2f676574706f73746d616e2d69636f6e2e737667',
    name: 'Postman',
  },
];
